import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function CheckoutCancelPage() {
  return (
    <div className="min-h-screen app-shell flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
          style={{ background: 'rgba(239,68,68,0.1)' }}>
          <XCircle size={48} className="text-red-400" />
        </div>
        <h2 className="font-heading text-xl font-bold text-slate-900 tracking-tight mb-3">Payment cancelled</h2>
        <p className="text-slate-400 mb-8">No charge was made. You can complete your registration whenever you're ready.</p>
        <Link to="/register">
          <Button className="w-full h-11" style={{ background: 'hsl(191,95%,43%)', color: 'hsl(222,47%,11%)' }}>
            Return to Registration
          </Button>
        </Link>
        <p className="mt-4 text-slate-500 text-sm">
          Already registered? <Link to="/login" className="text-cyan-400 hover:text-cyan-300">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
